import { render, staticRenderFns } from "./OrganismCustomerPermission.vue?vue&type=template&id=270556fc&scoped=true&"
import script from "./OrganismCustomerPermission.vue?vue&type=script&lang=js&"
export * from "./OrganismCustomerPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270556fc",
  null
  
)

export default component.exports